import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '../../../../../libs/src/models/account.model';
import { getAccountFullName } from '../../user/user.helpers';

@Pipe({
  name: 'appAccountFullName',
})
export class AccountFullNamePipe implements PipeTransform {
  transform(
    account: Pick<Account, 'first_name' | 'full_name' | 'last_name'>,
  ): string {
    return getAccountFullName(account);
  }
}
